import { MessageFileType } from 'enums/MessageFileType';
import { MediaInfo } from 'interfaces/MediaInfo';
import { Action } from 'redux';

import {
    ClearFileAction,
    FileActionType,
    FileNotUploadedAction,
    FileUploadedAction,
    FileUploadProgressAction,
    SetAllowedFileExtensionsAction,
    SetFileUploadSizeAction,
    UploadFileAction,
} from './files.actions';

const initialState = {
    allowed: false,
    allowedExtensions: [] as string[],
    uploads: {} as {
        [uuid: string]: MediaInfo & {
            file: File;
            fileName: string;
            type?: MessageFileType;
            sizeBytes: number;
            uploading: boolean;
            progress?: number;
            error?: string;
            badFile?: boolean;
        };
    },
};

export const filesReducer = (
    state = initialState,
    action: Action<FileActionType>,
): typeof initialState => {
    switch (action.type) {
        case FileActionType.SetAllowedExtensions:
            const allowedExtensions = (action as SetAllowedFileExtensionsAction).payload;
            return {
                ...state,
                allowed: allowedExtensions.length > 0,
                allowedExtensions,
            };

        case FileActionType.UploadFile:
            const uploadFile = (action as UploadFileAction).payload;
            return {
                ...state,
                uploads: {
                    ...state.uploads,
                    [uploadFile.uuid]: {
                        file: uploadFile.file,
                        fileName: uploadFile.file.name,
                        sizeBytes: uploadFile.file.size,
                        uploading: true,
                    },
                },
            };

        case FileActionType.FileUploadProgress:
            const progressInfo = (action as FileUploadProgressAction).payload;
            if (state.uploads[progressInfo.uuid]) {
                return {
                    ...state,
                    uploads: {
                        ...state.uploads,
                        [progressInfo.uuid]: {
                            ...state.uploads[progressInfo.uuid],
                            progress: progressInfo.progress,
                        },
                    },
                };
            } else {
                return state;
            }

        case FileActionType.SetFileUploadSize:
            const sizeInfo = (action as SetFileUploadSizeAction).payload;
            if (state.uploads[sizeInfo.uuid]) {
                return {
                    ...state,
                    uploads: {
                        ...state.uploads,
                        [sizeInfo.uuid]: {
                            ...state.uploads[sizeInfo.uuid],
                            sizeBytes: sizeInfo.size,
                        },
                    },
                };
            } else {
                return state;
            }

        case FileActionType.FileUploaded:
            const uploaded = (action as FileUploadedAction).payload;
            if (state.uploads[uploaded.uuid]) {
                return {
                    ...state,
                    uploads: {
                        ...state.uploads,
                        [uploaded.uuid]: {
                            ...state.uploads[uploaded.uuid],
                            uploading: false,
                            type: uploaded.type,
                            ...uploaded.info,
                        },
                    },
                };
            } else {
                return state;
            }

        case FileActionType.FileNotUploaded:
            const notUploaded = (action as FileNotUploadedAction).payload;
            if (state.uploads[notUploaded.uuid]) {
                return {
                    ...state,
                    uploads: {
                        ...state.uploads,
                        [notUploaded.uuid]: {
                            ...state.uploads[notUploaded.uuid],
                            uploading: false,
                            error: notUploaded.reason,
                            badFile: notUploaded.badFile,
                        },
                    },
                };
            } else {
                return state;
            }

        case FileActionType.ClearFile:
            const clearUuid = (action as ClearFileAction).payload;
            const uploads = { ...state.uploads };
            delete uploads[clearUuid];

            return {
                ...state,
                uploads,
            };

        case FileActionType.ClearFiles:
            return {
                ...state,
                uploads: {},
            };

        default:
            return state;
    }
};
